export const DEFAULT_LANGUAGE = 'en' as const;
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    shortLabel: 'EN',
    label: 'English',
    nativeLabel: 'English',
    flag: 'GB',
  },
  {
    code: 'al',
    shortLabel: 'AL',
    label: 'Albanian',
    nativeLabel: 'Shqip',
    flag: 'AL',
  },
  {
    code: 'it',
    shortLabel: 'IT',
    label: 'Italian',
    nativeLabel: 'Italiano',
    flag: 'IT',
  },
  {
    code: 'de',
    shortLabel: 'DE',
    label: 'German',
    nativeLabel: 'Deutsch',
    flag: 'DE',
  },
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]['code'];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((language) => language.code);
export const SUPPORTED_I18N_LANGUAGE_CODES = [...SUPPORTED_LANGUAGE_CODES, 'sq'] as const;

export function normalizeLanguage(language?: string | null): SupportedLanguage {
  if (!language) {
    return DEFAULT_LANGUAGE;
  }

  const baseLanguage = language.toLowerCase().split('-')[0];
  if (baseLanguage === 'sq') {
    return 'al';
  }

  const supportedLanguage = SUPPORTED_LANGUAGES.find((item) => item.code === baseLanguage);
  return supportedLanguage?.code ?? DEFAULT_LANGUAGE;
}

export function toLanguageTag(language?: string | null): string {
  const normalizedLanguage = normalizeLanguage(language);
  return normalizedLanguage === 'al' ? 'sq' : normalizedLanguage;
}

export function getLanguageMeta(language?: string | null) {
  const normalizedLanguage = normalizeLanguage(language);
  return SUPPORTED_LANGUAGES.find((item) => item.code === normalizedLanguage) ?? SUPPORTED_LANGUAGES[0];
}
